/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponseData;

  constructor(
    err: DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse";
  }
}

/** @internal */
export const DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$inboundSchema:
  z.ZodType<
    DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse(
        v,
      );
    });

/** @internal */
export type DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$outboundSchema:
  z.ZodType<
    DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$Outbound,
    z.ZodTypeDef,
    DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse
  > = z.instanceof(
    DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$ {
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$inboundSchema;
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$outboundSchema;
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$Outbound` instead. */
  export type Outbound =
    DeleteApiLeadScraperMicroserviceApiV1OrganizationIdErrorResponse$Outbound;
}
